import { generatePDF as generateBankPDF } from "../components/Documents/Download/BankDetailsDownload";
import { generatePDF as generateComplianceAndOtherDocumentsPDF } from "../components/Documents/Download/ComplianceAndOtherDocumentsDownload";
import { generatePDF as generateGdprJobApplicationProcessingConsentForm } from "../components/Documents/Download/GdprJobApplicationProcessingConsentFormDownload";
import { generatePDF as generateGdprPolicy } from "../components/Documents/Download/GdprPolicyDownload";
import { generatePDF as generateHealthQuestionnairePDF } from "../components/Documents/Download/HealthQuestionnaireDownload";
import { generatePDF as generateLfuk48hrOptOutFormPDF } from "../components/Documents/Download/Lfuk48hrOptOutFormDownload";
import { generatePDF as generateLfukKidForPayeFormPDF } from "../components/Documents/Download/LfukKidForPayeDownload";
import { generatePDF as generateLfukRecruitmentServicesLimitedTermsOfEngagement } from "../components/Documents/Download/LfukRecruitmentServicesLimitedTermsOfEngagementDownload";
import { generatePDF as generateLiteracyAndNumeracyAssessment } from "../components/Documents/Download/LiteracyNumeracyDownload";
import { generatePDF as generateNewStarterChecklist } from "../components/Documents/Download/NewStarterChecklistDownload";
import { generatePDF as generateWorkExperience } from "../components/Documents/Download/WorkExperienceDownload";

// Mapping document keys to their respective PDF generators
const documentGenerators = {
  bankDetails: generateBankPDF,
  complianceAndOtherDocuments: generateComplianceAndOtherDocumentsPDF,
  gdprJobApplicationProcessingConsentForm:
    generateGdprJobApplicationProcessingConsentForm,
  gdprPolicy: generateGdprPolicy,
  healthQuestionnaire: generateHealthQuestionnairePDF,
  lfuk48hrOptOutForm: generateLfuk48hrOptOutFormPDF,
  lfukKidForPaye: generateLfukKidForPayeFormPDF,
  lfukRecruitmentServicesLimitedTermsOfEngagement:
    generateLfukRecruitmentServicesLimitedTermsOfEngagement,
  literacyAndNumeracyAssessment: generateLiteracyAndNumeracyAssessment,
  newStarterChecklist: generateNewStarterChecklist,
  workExperience: generateWorkExperience,
};

// Function to generate PDFs sequentially
const generateAllPDFs = async (items, obj, sasToken, token, candidateId) => {
  const isSendToTalentTrail = true;
  for (const item of items) {
    if (item.progress === 100) {
      const generatePDF = documentGenerators[item.key];
      if (generatePDF) {
        try {
          await generatePDF(item, obj["userDetail"], sasToken, isSendToTalentTrail, token, candidateId);
        } catch (error) {
          console.error(`Error generating PDF for ${item.key}:`, error);
        }
      } else {
        console.warn(`No handler found for key: ${item.key}`);
      }
    }
  }
};

export const uploadAllDocuments = async (obj, sasToken, token, candidateId) => {
  try {
    const items = Object.values(obj).filter((item) => item.progress === 100);
    await generateAllPDFs(items, obj, sasToken, token, candidateId);
    console.log("All documents downloaded successfully!");
  } catch (error) {
    console.error("Unexpected error in document download process:", error);
  }
};
